import React from 'react';
import { Box, Button, IconButton, Modal } from '@material-ui/core';
import DeleteOutlineRounded from '@material-ui/icons/DeleteOutlineRounded';
import { useDispatch } from 'react-redux';
import useToast from '../../../hooks/useToast';
import {
  deleteOneProgramAsync,
  getAllProgramsAsync,
} from './ProgramStore/programStoreSlice';
import CloseIcon from '@material-ui/icons/Close';
import useLoader from '../../../hooks/useLoader';
import EditIcon from '@material-ui/icons/Edit';
import UpdateProgram from './UpdateProgram';

export const programsColumn = [
  // { Header: 'ID', accessor: '_id' },
  { Header: 'Program Name', accessor: 'name' },
  {
    Header: 'Action',
    accessor: '',
    Cell: (val) => {
      const dispatch = useDispatch();
      const payload = val.cell.row.original;
      const { _id } = payload;
      const { ErrorToast, SuccessToast } = useToast();
      const { handleLoader } = useLoader();

      const [selectedId, setSelectedId] = React.useState(null);
      const [openConfirmModal, setOpenConfirmModal] = React.useState(false);

      const handleOpenConfirmModal = (id) => {
        setSelectedId(id);
        setOpenConfirmModal(true);
      };
      const handleCloseConfirmModal = () => {
        setSelectedId(null);
        setOpenConfirmModal(false);
      };

      const [updateProgramModal, setUpdateProgramModal] = React.useState(false);

      const handleOpenProgramModal = (courseData) => {
        setUpdateProgramModal(courseData);
      };
      const handleCloseProgramModal = () => setUpdateProgramModal(false);

      const handleDeleteOneProgram = async (programId) => {
        try {
          handleLoader(true);
          dispatch(deleteOneProgramAsync(programId))
            .unwrap()
            .then((res) => {
              if (res) {
                handleLoader(false);
                SuccessToast(`Program deleted successfully.`);
                dispatch(getAllProgramsAsync());
              } else {
                handleLoader(false);
              }
            });
        } catch (error) {
          console.log({ error });
          handleLoader(false);
          ErrorToast(`Program could not be deleted. Please try again!`);
        }
      };

      const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 3,
        fontFamily: 'Rubik',
        borderRadius: '6px',
      };

      return (
        <>
          <IconButton onClick={() => handleOpenProgramModal(payload)}>
            <EditIcon color="secondary" />
          </IconButton>
          {/* disabled true for not breaking the ui in ath-global */}
          <IconButton
            onClick={() => handleOpenConfirmModal(_id)}
            disabled={true}>
            <DeleteOutlineRounded htmlColor="#dfdfdf" />
            {/* color="primary" */}
          </IconButton>

          <Modal
            open={updateProgramModal}
            onClose={handleCloseProgramModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description">
            <UpdateProgram
              programData={updateProgramModal}
              handleClose={handleCloseProgramModal}
            />
          </Modal>

          <Modal
            open={openConfirmModal}
            onClose={handleCloseConfirmModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description">
            <Box sx={style}>
              <Box mb={5} sx={{ fontSize: 20, fontWeight: 'medium' }}>
                Are you sure you want to delete ?
              </Box>
              <Box sx={{ position: 'absolute', top: 5, right: 5 }}>
                <IconButton>
                  <CloseIcon />
                </IconButton>
              </Box>
              <Box display={'flex'} justifyContent="flex-end">
                <Box display={'flex'}>
                  <Box mr={1}>
                    <Button
                      variant="outlined"
                      color="primary"
                      onClick={handleCloseConfirmModal}>
                      No
                    </Button>
                  </Box>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => handleDeleteOneProgram(selectedId)}>
                    Yes
                  </Button>
                </Box>
              </Box>
            </Box>
          </Modal>
        </>
      );
    },
  },
];
